import TimeTrackingLanding from "./TimeTrackingLanding";

const TIME_TRACKING_LANDING_PATH = "/time-tracking-landing";

export { TimeTrackingLanding, TIME_TRACKING_LANDING_PATH };
